import React, { useEffect, useRef } from 'react';

import { StyledSecondIFrame } from './RCX.styled';

type SecondIFrameProps = {
    visible: boolean;
    id: string;
    url?: string;
    onLoaded?: (iframe: HTMLIFrameElement) => void;
};

export const SecondIFrame: React.FC<SecondIFrameProps> = ({ visible, id, url, onLoaded }) => {
    const secondIframeRef = useRef<HTMLIFrameElement | null>(null);

    useEffect(() => {
        if (secondIframeRef.current && url) {
            onLoaded && onLoaded(secondIframeRef.current);
        }
    }, [url]);

    return (
        <StyledSecondIFrame
            ref={secondIframeRef}
            id='ringcx-second-iframe'
            allow='microphone *'
            src={url}
            title='RingCX Second IFrame'
            width={visible ? '100%' : 0}
            data-aid={id}
        />
    );
};
